// @flow
/* eslint-disable no-shadow */
import React from 'react';
import Toggle from 'react-toggled';
import { connect } from 'react-redux';
import { useTheme } from '@material-ui/styles';
import Link from '@material-ui/core/Link';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import { Avatar } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import { getDisplayId, getDisplayName, getAvaName, getUserColor } from '../../utils/user';
import EditProfileModal from '../../modules/scribe/EditProfileModal';
import AvatarLogo from '../Icons/AvatarLogo';

function User({
  currentPlatform,
  firebaseUser,
  subscription,
  t,
  user,
}: {
  t: Object,
  theme: Object,
  user: Object,
  subscription: Object,
  firebaseUser: Object,
  currentPlatform: string,
}) {
  const theme = useTheme();

  const getSubscriptionDisplay = () => {
    const { ongoingSubscription, ongoingSubscriptionSubtype } = subscription;
    const subscriptionLabel = ongoingSubscription === 'Freedom' ? 'Community' : ongoingSubscription;

    return `Ava ${subscriptionLabel} ${ongoingSubscriptionSubtype}`;
  };

  return (
    <ListItem
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'start',
        outline: 'none',
      }}
    >
      <div style={{ flexGrow: 1 }} />
      {user && firebaseUser && user.userPhoto && user.userPhoto.url ? (
        <Avatar
          src={user.userPhoto.url}
          alt="profile_photo"
          style={{
            margin: 'auto',
            marginRight: 12,
            width: 36,
            height: 36,
            backgroundColor: getUserColor(user && user.userName),
          }}
        >
          {user && user.userName && user.userName[0].toUpperCase()}
        </Avatar>
      ) : (
        <div style={{ margin: 'auto', marginRight: 12 }}>
          <AvatarLogo
            color={
              theme.palette.type === 'light'
                ? theme.palette.ava.navyGroup.convoText
                : theme.palette.ava.navyGroup.convoTextDark
            }
            width={40}
            height={40}
          />
        </div>
      )}
      {user && (
        <ListItemText
          className="hover-parent"
          style={{
            width: '100%',
          }}
        >
          <Toggle>
            {({ on, getTogglerProps, setOff }) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    cursor: currentPlatform === 'web' ? 'pointer' : undefined,
                  }}
                  {...(currentPlatform === 'web' ? getTogglerProps() : {})}
                >
                  <Typography variant="h6" noWrap>
                    {getDisplayName(user)}
                  </Typography>
                </div>
                {on && <EditProfileModal open={on} close={setOff} />}
              </div>
            )}
          </Toggle>
          {getAvaName(user) && (
            <Typography
              style={{
                marginTop: -10,
              }}
              noWrap
              color="primary"
              variant="subtitle1"
            >
              <small>
                <strong>{`&${getAvaName(user)}`}</strong>
              </small>
            </Typography>
          )}
          <Typography
            style={{
              marginTop: -10,
            }}
            noWrap
            color="primary"
            variant="subtitle1"
          >
            <small>{getDisplayId(user, t)}</small>
          </Typography>
          {subscription && subscription.ongoingSubscription && (
            <Typography style={{ marginTop: -10 }} variant="subtitle1" noWrap>
              <small>{getSubscriptionDisplay()}</small>
            </Typography>
          )}
          {user?.profile?.orgProperties?.role === 'admin' && (
            <Typography
              style={{
                marginTop: -10,
              }}
              noWrap
              color="secondary"
              variant="subtitle1"
            >
              <small>
                <Link
                  style={{
                    color: '#777',
                    fontWeight: 600,
                  }}
                  target="_blank"
                  rel="noreferrer noopener"
                  href="/account/dashboard"
                >
                  {t('sidebar.adminDashboard')}

                  <OpenInNewOutlinedIcon
                    style={{
                      fontSize: '1em',
                      transform: 'translate(0.2em, 0.16em)',
                    }}
                  />
                </Link>
              </small>
            </Typography>
          )}
        </ListItemText>
      )}
    </ListItem>
  );
}

const mapStateToProps = ({ scribeSession: { captioner, currentPlatform, subscription }, firebase: { user } }) => ({
  currentPlatform,
  firebaseUser: user,
  subscription,
  user: captioner,
});

export default connect(mapStateToProps, {})(withTranslation()(User));
